



// Anchor jump helper that keeps correcting position as lazy-loaded
// content above the target shifts layout.
function jumpToHashInstant(id) {
    if (!id) return;

    // External or non-hash link → let browser handle it normally.
    if (id.charAt(0) !== "#") {
        window.location.href = id;
        return;
    }

    var targetId = id.slice(1);
    if (!targetId) return;

    var target = document.getElementById(targetId);

    // If target doesn't exist yet, just update hash and let browser do its best.
    if (!target) {
        if (history.pushState) {
            history.pushState(null, "", id);
        } else {
            window.location.hash = id;
        }
        return;
    }

    // Update URL without triggering the browser's own scroll (pushState path).
    if (history.pushState) {
        history.pushState(null, "", id);
    } else {
        window.location.hash = id;
    }

    var maxAttempts = 10;
    var attempt = 0;
    var lastTop = null;

    function adjustScroll() {
        var rect = target.getBoundingClientRect();
        var absoluteTop = window.pageYOffset + rect.top;

        // If the position has stabilized within 1px, stop adjusting.
        if (lastTop !== null && Math.abs(absoluteTop - lastTop) < 1) {
            return;
        }

        lastTop = absoluteTop;
        window.scrollTo(0, absoluteTop);

        attempt += 1;
        if (attempt < maxAttempts) {
            setTimeout(adjustScroll, 300);
        }
    }

    // Initial jump plus follow-up corrections while lazy content loads.
    adjustScroll();

    // Temporarily highlight the target element.
    var highlightClass = "scroll-highlight-animation";
    target.classList.add(highlightClass);
    setTimeout(function () {
        target.classList.remove(highlightClass);
    }, 7000);
}

// Intercept in-page anchor clicks before theme.min.js smooth-scroll logic.
document.addEventListener(
    "click",
    function (e) {
        var anchor = e.target.closest && e.target.closest("a[href^='#']");
        if (!anchor) return;

        var id = anchor.getAttribute("href");
        if (!id || id === "#") return;

        // Cancel any existing smooth-scroll handlers bound later in the bubble phase.
        e.stopImmediatePropagation();
        e.preventDefault();

        // Perform an instant jump that keeps correcting as content loads.
        jumpToHashInstant(id);
    },
    true // capture so this runs before theme.min.js bubbling handlers
);


document.addEventListener("DOMContentLoaded", function () {
    const lazyVideos = document.querySelectorAll("video.lazy-video");

    // Utility: detect mobile
    function isMobile() {
      return typeof window !== "undefined" && (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    }

    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            // If video has 'mobile-disabled' class, do NOT load it on mobile devices
            if (video.classList.contains('mobile-disabled') && isMobile()) {
              observer.unobserve(video);
              return;
            }
            const sources = JSON.parse(video.dataset.sources);

            // Append all sources
            sources.forEach(s => {
              const source = document.createElement("source");
              source.src = s.src;
              source.type = s.type;
              video.appendChild(source);
            });

            // Load video now
            video.load();
            observer.unobserve(video);
          }
        });
      });

      lazyVideos.forEach(video => videoObserver.observe(video));
    }
  });

  var playStatus = 'true';
document.addEventListener('DOMContentLoaded', function() {
  // Initialize video modal functionality for all modals on the page
  function initializeVideoModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) {
      console.warn('Video modal not found:', modalId);
      return;
    }
    console.log('Initializing video modal:', modalId);
    
    const modalVideo = modal.querySelector('.video-modal-player');
    const closeButton = modal.querySelector('.video-modal-close-btn');
    
    // Store the original YouTube src for autoplay toggling
    let youtubeSrc = null;
    if (modalVideo && modalVideo.tagName === 'IFRAME') {
      youtubeSrc = modalVideo.getAttribute('src');
    }
    
    // Function to open modal
    function openModal() {
        console.log('play status =' + playStatus);
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('video-modal-open');
      if (modal.classList.contains('header-video-modal')) {
        document.body.classList.add('header-modal');
      }
      
      // Auto-play video if it's an HTML5 video element
      if (modalVideo && modalVideo.tagName === 'VIDEO') {
        modalVideo.play();
      }
      
      // Autoplay YouTube iframe by appending autoplay=1
      if (modalVideo && modalVideo.tagName === 'IFRAME' && playStatus != 'false') {
        if (!youtubeSrc) {
          youtubeSrc = modalVideo.getAttribute('src');
        }
        // Only add autoplay=1 if not already present
        let newSrc = youtubeSrc;
        if (newSrc.indexOf('autoplay=1') === -1) {
          if (newSrc.indexOf('?') !== -1) {
            newSrc += '&autoplay=1';
          } else {
            newSrc += '?autoplay=1';
          }
        }
        modalVideo.src = newSrc;
      }
    }
    
    // Function to close modal
    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      document.body.classList.remove('video-modal-open');
      document.body.classList.remove('header-modal');
      // Pause video if it's an HTML5 video element
      if (modalVideo && modalVideo.tagName === 'VIDEO') {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      } else if (modalVideo && modalVideo.tagName === 'IFRAME') {
        // Reset YouTube src to remove autoplay
        if (youtubeSrc) {
          modalVideo.src = youtubeSrc;
        }
      }
    }
    
    // Close button event listener
    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }
    
    // Click outside to close
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    // Find and attach click handlers to trigger buttons
    const triggerButtons = document.querySelectorAll('[data-video-modal="' + modalId + '"]');
    console.log('Found trigger buttons for', modalId + ':', triggerButtons.length);
    triggerButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Opening modal:', modalId);
        // if(modalId == 'prod-video'){
        //     playStatus = 'false';
        // }
        openModal();
      });
    });
    
    // Store modal functions for external access
    window.videoModals = window.videoModals || {};
    window.videoModals[modalId] = {
      open: openModal,
      close: closeModal
    };
  }
  
  // Initialize all video modals on the page
  const videoModals = document.querySelectorAll('[class*="video-modal"], [class*="adventure-watch__video-modal"], [class*="episodes-card__video-modal"]');
  const processedModals = new Set();
  
  console.log('Found video modals:', videoModals.length);
  
  videoModals.forEach(function(modal) {
    const modalId = modal.id;
    console.log('Processing modal:', modalId, modal.className);
    if (modalId && !processedModals.has(modalId)) {
      processedModals.add(modalId);
      initializeVideoModal(modalId);
    }
  });
  
  // Global function to open any video modal by ID
  window.openVideoModal = function(modalId) {
    if (window.videoModals && window.videoModals[modalId]) {
      window.videoModals[modalId].open();
    }
  };
  
  // Global function to close any video modal by ID
  window.closeVideoModal = function(modalId) {
    if (window.videoModals && window.videoModals[modalId]) {
      window.videoModals[modalId].close();
    }
  };
});


// desktop menu open start
document.addEventListener("DOMContentLoaded", function () {

    const headerLists = document.querySelectorAll(".header__list");
    headerLists.forEach(function (item) {
        item.addEventListener("mouseenter", function () {
            document.body.classList.add("desk-menu-open");
        });
        item.addEventListener("mouseleave", function () {
            document.body.classList.remove("desk-menu-open");
        });
    });
});
// desktop menu open end




// game-live-part marquee start also homepage-squad-spoken marquee
$(".squad-spoken__wrap").slick({
    infinite: true,
    speed: 500,
    variableWidth: true,
    arrows: false,
    slidesToScroll: 2,
    touchThreshold: 20,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    focusOnSelect: false,
    draggable: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
        variableWidth: false,
      }
    }
  ]
});

$(".template-cake-bar-up .game-hghlights__wrap").slick({
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
    {
      breakpoint: 992,
      settings: "unslick"
    }
  ]
});
// $('.squad-spoken__wrap').on('afterChange', function(event, slick) {
//   slick.$slides.each(function(index, slide) {
//     $(slide).css('transform', 'translateZ(0)');
//   });
// });

if($('.announcement__wrapper_slider').length > 0){
    $('.announcement__wrapper_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        vertical: true,
        focusOnSelect: false,
    });
}

$(".game-live-part__slider").slick({
    speed: 300,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    pauseOnHover: false,
    focusOnSelect: false,
    draggable: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2,
        variableWidth: false,
      }
    }
    ]
});

// game-live-part marquee end also homepage-squad-spoken marquee




if ($(Window).width() < 768) {
    $('.shop-range__wrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}





var windowWidth = $(window).width();
if (windowWidth <= 991) {
    $('.compare__table-right').click(function () {
        $('body').addClass('compare-modal-open');
        // $('.compare-modal').fadeIn(300);
    });
    $('.compare-modal__item').click(function () {
        $('.compare-modal__item').removeClass('compare-modal__item_active');
        var compare_item = $(this).attr('compare-item');
        var imagesrc = $(this).attr('image-src');
        $('.compare__table-img-item img').attr('src', imagesrc);
        $('.compare__table-content-right-item').removeClass('compare__table-content-right-item_active');
        $(compare_item).addClass('compare__table-content-right-item_active');

        $(this).addClass('compare-modal__item_active');
        $('body').removeClass('compare-modal-open');


        $('.compare__table-content-right-item-wrap').removeClass('visible');
        var $wraps = $(compare_item).find('.compare__table-content-right-item-wrap');
        $wraps.each(function (i, el) {
            setTimeout(function () {
                $(el).addClass('visible');
            }, i * 80);
        });
    });
    $('.compare-modal').click(function () {
        $('body').removeClass('compare-modal-open');
    });
}

// mission-highlight video start

$(document).on("click", ".mission-highlight__play-icon", function () {
    const $wrap = $(this).closest(".mission-highlight__video");
    const video = $wrap.find("video").get(0);
    video.muted = false;
    video.play();
    $(this).fadeOut(200);
});
$(document).on("click", ".mission-highlight__video video", function () {
    const $wrap = $(this).closest(".mission-highlight__video");
    const $icon = $wrap.find(".mission-highlight__play-icon");
    this.pause();
    $icon.fadeIn(200);
});

// mission-highlight video end



// jungle-difference mobile slider start

if ($(Window).width() < 768) {
    $('.jungle-difference__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}

// jungle-difference mobile slider end





// btn hover start


$(function () {
    $('.btn')
        .on('mouseenter', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        })
        .on('mouseout', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        });
    $('[href="#"]').on('click', function (e) {
        e.preventDefault();
    });
});
// btn hover end



  // Rulebook open/close
  $(".begin-btn-learn").on('click', function () {
    $('body').addClass('rulebook-open');
  });
  $(".rulebook__close , .overlay").on('click', function () {
    $('body').removeClass('rulebook-open');
  });
  $(".rule-btn").on('click', function () {
    $('body').addClass('rulebook-open');
  });

  // Tabs inside rulebook (vanilla JS is fine here)
  const tabs = document.querySelectorAll(".rulebook__tab");
  const contents = document.querySelectorAll(".rulebook__tabs-content-item");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      if (contents[index]) {
        contents[index].classList.add("active");
      }
    });
  });

  if (tabs[0] && contents[0]) {
    tabs[0].classList.add("active");
    contents[0].classList.add("active");
  }

  // Smooth scroll for all anchor links with hashes
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      if (targetId === '#' || targetId === '') return;

      e.preventDefault();

      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        targetEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      $("body").removeClass('menu-open');
      $(".header__mobi-menu").removeClass('active');
    });
  });

  // Rellax initialisation
  var rellax;
  if ($(window).width() <= 768) {
    $('.rellax').each(function () {
      if (!$(this).hasClass('rellax-remove-mobile')) {
        rellax = new Rellax(this, {
          center: true,
        });
      }
    });
  } else {
    rellax = new Rellax('.rellax', {
      center: true,
    });
  }

  // Tab Button Hide Show Wild Guide Page
  $(".guide-tab__filtar").on("click", function (e) {
    e.preventDefault();

    if ($(window).width() <= 1024) {
      $(this).siblings("ul").stop(true, true).slideToggle(300);
    }
  });

  // Popular Card Slider Wild Guide Page
  $('.popular__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.popular__next-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
  });
  $('.popular__prev-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });



$('body').on('click', '.click-shake', function () {
    var $this = $(this);
    $this.addClass('shake-it');
    setTimeout(function () {
        $this.removeClass('shake-it');
    }, 900)
})


$('.product-add-btn').on('click', function () {
    const $button = $(this);
    const $span = $button.find('span');
    const originalText = $span.text();
    const newText = "Added to cart";

    setTimeout(() => {
        $span.text(newText);
        $button.attr('data-text', newText);
    }, 300);
    setTimeout(() => {
        $span.text(originalText);
        $button.attr('data-text', originalText);
    }, 7000);
})


// header mobi menu start

$(".header__mobi-menu").on('click', function () {
    $(".header__mobi-menu").toggleClass('active');
})



document.addEventListener("DOMContentLoaded", function () {
    const announcement = document.querySelector(".announcement");
    const menu = document.querySelector(".menu");
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    menu.classList.add("header-sticky");
                } else {
                    menu.classList.remove("header-sticky");
                }
            });
        }, {
            root: null, // viewport
            threshold: 0,
        }
    );
    if (announcement) {
        observer.observe(announcement);
    }
});


// header mobi menu end


// video-slider start




$('.video-slider__items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    // pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
        }
    }, ]
});

// Function to add custom arrows
function addVideoArrows() {
    const sliderContainer = $('#video-slider__controls');
    const leftImg = sliderContainer.data('left');
    const rightImg = sliderContainer.data('right');
    const slickDots = $('.video-slider__items').find('.slick-dots');
    if ($(window).width() < 1024) {
        if ($('.video-slider__items-arrow-pre').length === 0) {
            const leftArrow = $('<div>', {
                class: 'video-slider__items-arrow-pre',
                html: `<img src="${leftImg}" alt="logo" />`,
                role: 'button',
                'aria-label': 'Previous slide'
            }).appendTo(slickDots);

            const rightArrow = $('<div>', {
                class: 'video-slider__items-arrow-next',
                html: `<img src="${rightImg}" alt="logo" />`,
                role: 'button',
                'aria-label': 'Next slide'
            }).appendTo(slickDots);

            leftArrow.on('click', function () {
                $('.video-slider__items').slick('slickPrev');
            });
            rightArrow.on('click', function () {
                $('.video-slider__items').slick('slickNext');
            });

            slickDots.css('position', 'relative');
            leftArrow.css({
                position: 'absolute',
                left: '-42px',
                top: '50%',
                transform: 'translateY(-43%)',
                border: 'none',
                width: '24px',
                height: '24px',
                cursor: 'pointer',
            });
            rightArrow.css({
                position: 'absolute',
                right: '-42px',
                top: '50%',
                transform: 'translateY(-43%)',
                border: 'none',
                width: '24px',
                height: '24px',
                cursor: 'pointer',
            });
        }
    } else {
        $('.video-slider__items-arrow-pre, .video-slider__items-arrow-next').remove();
    }
}

// ✅ Correct function call
addVideoArrows();

// ✅ Reapply on resize
$(window).resize(function () {
    addVideoArrows();
});

// Ensure arrows render after Slick setup
$('.video-slider__items').slick('setPosition');





$(".video-slider__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).siblings("video").get(0);
    var icon_image = $(this);

    if (video.paused) {
        $(".video-slider__item video").each(function () {
            this.pause();
            $(".video-slider__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});

// Toggle play/pause when clicking on the video
$(".video-slider__item video").click(function () {
    var video = this;
    var icon_image = $(this).siblings(".video-slider__video-play-icon");

    if (video.paused) {
        $(".video-slider__item video").each(function () {
            this.pause();
            $(".video-slider__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});






$('.video-slider__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.video-slider__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// video-slider end




// reviews start

$('.reviews__items').slick({
    slidesToShow: 1,
    mobileFirst: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'cubic-bezier(0.75, 0.01, 0.76, 1)',
    // pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.reviews__arrow_left'),
            nextArrow: $('.reviews__arrow_right'),
        }
    }]

});


// reviews end



// game-changer start

const items = $('.game-changer__item');
const animationClass = 'animate'; // Add your animation class here

function animateItems() {
    items.each(function (index, item) {
        const $item = $(item);
        const itemOffset = $item.offset().top;
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();

        if (scrollTop + windowHeight - 300 > itemOffset && !$item.hasClass(animationClass)) {
            setTimeout(() => {
                $item.addClass(animationClass);
            }, index * 200); // Delay each item's animation
        }
    });
}

$(window).on('scroll', animateItems);
animateItems(); // Trigger on page load in case items are already in view


$('.game-changer__items').slick({
    slidesToShow: 1,
    mobileFirst: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [{
        breakpoint: 1024,
        settings: "unslick"
    }]

});

// game-changer end







// compare start




$('.compare__table-img-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    autoplay: true,
    autoplaySpeed: 4000,
    asNavFor: '.compare__table-content-right-items',
    responsive: [{
        breakpoint: 768,
        settings: "unslick"
    }, ]
});

$('.compare__table-content-right-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.compare__table-img-items',
    focusOnSelect: true,
    arrows: false,
    fade: true,
    speed: 200,
    responsive: [{
        breakpoint: 768,
        settings: "unslick"
    }, ]
});



$('.compare__mobi-change').on('click', function () {
    $('.compare__table-img-items').slick('slickNext');
    $('.compare__table-content-right-items').slick('slickNext');
});






$('.compare__table-left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.compare__table-right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});





// compare end




// menu dropdown start


$(".menu__arrow").click(function (e) {
    e.preventDefault(); // prevent the page from jumping to top

    const $parentLi = $(this).parent('li');

    if ($parentLi.hasClass('active')) {
        $parentLi.removeClass("active");
        $parentLi.find(".menu__list-content").slideUp();
    } else {
        $(".menu__list-content").slideUp();
        $(".menu__list ul li").removeClass("active");
        $parentLi.addClass("active");
        $parentLi.find(".menu__list-content").slideDown();
    }
});


// menu dropdown end


// menu start


$(".header__mobi-menu").on('click', function () {
    $("body").toggleClass('menu-open');
})




// menu end


// product start




var _productSlidersDesktop = null;
var _productSliderResizeTimer;

function initProductSliders() {
    var $big   = $('.product__big-imgs');
    var $small = $('.product__small-imgs');
    var $small_cake = $('.product__small-imgs_cake');
    if (!$big.length || !$small.length) return;

    var isDesktop = $(window).width() >= 1024;

    // Only rebuild when crossing the breakpoint, not on every resize event
    if (isDesktop === _productSlidersDesktop) return;
    _productSlidersDesktop = isDesktop;

    if ($big.hasClass('slick-initialized'))   $big.slick('unslick');
    if ($small.hasClass('slick-initialized')) $small.slick('unslick');
    if ($small_cake.hasClass('slick-initialized')) $small_cake.slick('unslick');

    $big.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        asNavFor: '.product__small-imgs'
    });

    $small.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product__big-imgs',
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
        infinite: false,
        // vertical: isDesktop,
        variableWidth: !isDesktop
    });

    $small_cake.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product__big-imgs',
        // centerMode: false,
        focusOnSelect: true,
        arrows: false,
        infinite: false,
        // vertical: isDesktop,
        variableWidth: !isDesktop
    });
}

initProductSliders();

$(window).on('resize', function () {
    clearTimeout(_productSliderResizeTimer);
    _productSliderResizeTimer = setTimeout(initProductSliders, 200);
});


if($(".product__dropdown-item").length > 0){
    $(".product__dropdown-item").each(function(){
        if($(this).hasClass('active')){
            $(this).find(".product__dropdown-content").show();
        }
    });

    $(".product__dropdown-item").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).find(".product__dropdown-content").slideUp();
        } else {
            $(".product__dropdown-item").removeClass("active");
            $(".product__dropdown-content").slideUp();
            $(this).addClass("active");
            $(this).find(".product__dropdown-content").slideDown();
        }
    });
}



// product end



// game-slider star

$(document).ready(function () {
    $('.game-slider__items').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false, // Disabling default arrows
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        adaptiveHeight: false,
        pauseOnHover: true,
        // cssEase:'cubic-bezier(0.88, 0.01, 0.08, 1.45)',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
            }
        }]
    });
    // Wait until Slick is fully initialized and then add the custom arrows
    // Function to add custom arrows
    function addCustomArrows() {
        const slickDots = $('.game-slider__items').find('.slick-dots');
        // Check if the viewport width is greater than 1024px
        if ($(window).width() > 1024) {
            // Check if the custom arrows already exist, if not, create them
            if ($('.slick-prev-custom').length === 0) {
                const leftArrow = $('<div>', {
                    class: 'slick-prev-custom',
                    html: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path d="M10.4785 12L6.47852 8L10.4785 4" stroke="#313E20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
                    role: 'button',
                    'aria-label': 'Previous slide'
                }).appendTo(slickDots);
                const rightArrow = $('<div>', {
                    class: 'slick-next-custom',
                    html: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path d="M6.47852 12L10.4785 8L6.47852 4" stroke="#313E20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
                    role: 'button',
                    'aria-label': 'Next slide'
                }).appendTo(slickDots);
                // Add click functionality to arrows
                leftArrow.on('click', function () {
                    $('.game-slider__items').slick('slickPrev');
                });
                rightArrow.on('click', function () {
                    $('.game-slider__items').slick('slickNext');
                });
                // Style the arrows using CSS
                slickDots.css('position', 'relative'); // Ensure the parent container is positioned
                // Position the arrows absolutely within the slick-dots container
                leftArrow.css({
                    position: 'absolute',
                    left: '5px', // Adjust as necessary
                    top: '50%',
                    transform: 'translateY(-50%)',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                });
                rightArrow.css({
                    position: 'absolute',
                    right: '5px', // Adjust as necessary
                    top: '50%',
                    transform: 'translateY(-50%)',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                });
            }
        } else {
            // Remove the custom arrows if the width is <= 1024px
            $('.slick-prev-custom, .slick-next-custom').remove();
        }
    }
    // Initial setup for adding arrows
    addCustomArrows();
    // Re-add arrows on window resize
    $(window).resize(function () {
        addCustomArrows();
    });
    // Trigger the 'setPosition' event to ensure the arrows are positioned after carousel setup
    $('.game-slider__items').slick('setPosition');
});

// game-slider end




//collect start


$(".collect__video, .collect__video-play").click(function (e) {
    e.stopPropagation();

    var video = $(this).closest(".collect__video").find("video").get(0);
    var icon = $(this).closest(".collect__video").find(".collect__video-play");

    if (video.paused) {
        // Pause all other videos
        $("video").each(function () {
            this.pause();
            $(".collect__video-play").css("display", "block");
        });

        video.play();
        icon.css("display", "none");
    } else {
        video.pause();
        icon.css("display", "block");
    }
});



//collect end




// faq start


$(".accordion-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion-content").slideUp();
    } else {
        $(".accordion-content").slideUp();
        $(".accordion-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion-content").slideDown();
    }
})

// faq end



// cart-slider start


// $('.cart-drawer__slider-items').slick({
//     dots: true,
//     infinite: true,
//     slidesToShow: 1,
//     arrows: false,
// });



$("body").on('click', '.header__cart', function () {
    $("body").addClass('cart-open');
})
// $(".cart-drawer__close , .overlay").on('click', function () {
//     $("body").removeClass('cart-open');
//     $('body').removeClass('compare-modal-open');
// })
$(document).on('click', '.cart-drawer__close, .overlay ', function(){
    $("body").removeClass('cart-open');
    $('body').removeClass('compare-modal-open');
    // $('.episodes-card__video-modal').hide();
    Object.values(window.videoModals).forEach(modal => modal?.close?.());
})


// cart-slider end



//--------------- Ordering for desktop column wise start
function handleResponsiveOrdering() {
    if ($(window).width() > 1024) {
        const items = document.querySelectorAll('.shop-hero__content ul li');
        const totalItems = items.length;
        const half = Math.ceil(totalItems / 2);
        let oddOrder = 1;
        let evenOrder = 2;
        items.forEach((item, index) => {
            if (index < half) {
                item.style.order = oddOrder;
                oddOrder += 2;
            } else {
                item.style.order = evenOrder;
                evenOrder += 2;
            }
        });
    } else {
        document.querySelectorAll('.shop-hero__content ul li').forEach(item => {
            item.style.order = '';
        });
    }
}
// Run on load
$(document).ready(function () {
    handleResponsiveOrdering();
});
// Run on resize (with debounce)
let resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResponsiveOrdering, 150);
});
// //--------------- Ordering for desktop column wise end





// nutrition-modal start



document.addEventListener("DOMContentLoaded", function () {
    const nutritionTab = document.querySelector('.nutrition-modal__nutrition');
    const ingredientsTab = document.querySelector('.nutrition-modal__ingredients');
    const nutritionInfo = document.querySelector('.nutrition-modal__nutrition-info');
    const ingredientsInfo = document.querySelector('.nutrition-modal__ingredients-info');

    // If the nutrition modal isn't present on this page, skip wiring up handlers.
    if (!nutritionTab || !ingredientsTab || !nutritionInfo || !ingredientsInfo) {
        return;
    }

    function showNutrition() {
        nutritionInfo.classList.add('active');
        ingredientsInfo.classList.remove('active');
        nutritionTab.classList.add('active');
        ingredientsTab.classList.remove('active');
    }

    function showIngredients() {
        ingredientsInfo.classList.add('active');
        nutritionInfo.classList.remove('active');
        ingredientsTab.classList.add('active');
        nutritionTab.classList.remove('active');
    }

    nutritionTab.addEventListener('click', showNutrition);
    ingredientsTab.addEventListener('click', showIngredients);

    // Set initial state
    showNutrition();
});

$(".product-nut-btn").on('click', function (e) {
    e.preventDefault();
    $('body').addClass('nutrition-modal-show');
})
$(".nutrition-modal__close , .overlay").on('click', function () {
    $('body').removeClass('nutrition-modal-show');
})



// nutrition-modal end

$('.slick-current .compare__table-content-right-item-wrap').addClass('visible');
$('.compare__table-content-right-item_active .compare__table-content-right-item-wrap').addClass('visible');


$('.compare__table-content-right-items').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.compare__table-content-right-item-wrap').removeClass('visible');
    var $wraps = $(slick.$slides[currentSlide]).find('.compare__table-content-right-item-wrap');
    $wraps.each(function (i, el) {
        setTimeout(function () {
            $(el).addClass('visible');
        }, i * 80);
    });
});



// character-modal start



$(".character-modal__btn-card-view").on('click', function () {
    var character = $(this).attr("data-img");
    $(".character-modal__btn-character-view").removeClass("active");
    $(this).addClass("active");
    $(".character-modal__left-img img").attr("src", character);
})


$(".character-modal__btn-character-view").on('click', function () {
    var character = $(this).attr("data-img");
    $(".character-modal__btn-card-view").removeClass("active");
    $(this).addClass("active");
    $(".character-modal__left-img img").attr("src", character);
})




// new start here 

let characterData = [];

// Collect character data from each card
$(".character-card__item").each(function (index) {
    const $el = $(this);
    characterData.push({
        index: index, // used to track current item
        img: $el.data("pic"),
        card_img: $el.data("card-img"),
        title: $el.data("title"),
        availability: $el.data("availability"),
        description: $el.data("des"),
        type: $el.data("type"),
        logo: $el.data("logo"),
        productUrl: $el.data("product-url"),
        pageUrl: $el.data("page-url"),
        availability: $el.data("availability"),
        charactor_type: $el.data("character")
    });
});

let currentCharacterIndex = 0;


function updateNavText() {
    const prevBtn = $(".modal-nav[data-direction='prev']");
    const nextBtn = $(".modal-nav[data-direction='next']");

    const total = characterData.length;

    // Wrap around using modulus
    const prevIndex = (currentCharacterIndex - 1 + total) % total;
    const nextIndex = (currentCharacterIndex + 1) % total;

    // Set previous and next titles (always wrapped)
    prevBtn.text(characterData[prevIndex].title);
    nextBtn.text(characterData[nextIndex].title);
}


function update_availability(data) {
    const availability = data.toLowerCase();

    const $desktopEl = $(".character-modal__content-top-btn-text");

    const $mobileEl = $(".character-modal__mobi-headding-sub-title");

    let availabilityClass = "character-card__btn_gray";
    if (availability === "super rare") {
        availabilityClass = "character-card__btn_red";
    } else if (availability === "rare") {
        availabilityClass = "character-card__btn_green";
    }else if (availability === "super common") {
        availabilityClass = "character-card__btn_dark-orange";
    }
    $desktopEl
        .removeClass("character-card__btn_red character-card__btn_green character-card__btn_gray character-card__btn_dark-orange")
        .addClass(availabilityClass)
        .text(data.toUpperCase());

    $mobileEl
        .removeClass("character-card__btn_red character-card__btn_green character-card__btn_gray character-card__btn_dark-orange")
        .addClass(availabilityClass)
        .text(data.toUpperCase());
}


// Update the modal content
function updateModal(data) {
    $(".character-modal__left-img img").attr("src", data.img);
    $(".character-modal__btn-character-view").attr("data-img", data.img);
    $(".character-modal__right-card img").attr("src", data.card_img);
    $(".character-modal__btn-card-view").attr("data-img", data.card_img);
    $(".character-modal__mobi-headding-title-img img").attr("src", data.logo);
    $(".character-modal__content-desk-title-img img").attr("src", data.logo);
    $(".character-modal-btn-get span").text("Get " + data.title);
    $(".character-modal-btn-get").attr('data-text', "Get " + data.title);
    $(".character-modal-btn-watch span").text("Watch " + data.title + " episodes");
    $(".character-modal-btn-watch").attr('data-text', "Watch " + data.title + " episodes");
    $(".character-modal__content-top-sub-title-wrap h6").text(data.charactor_type);
    $(".character-modal__description").html(data.description);
    $(".character-modal-btn-watch").attr("href", data.pageUrl);
    // $(".character-modal-btn-get").attr("href", data.productUrl);
    $(".character-modal-btn-get").attr("href", 'https://junglesquad.com/products/jungle-squad-cards');
    if(data.charactor_type == 'hero' || data.charactor_type == 'Hero' || data.charactor_type == 'HERO'){
        $('.icon-hero').show();
        $('.icon-villain').hide();
    }else{
        $('.icon-hero').hide();
        $('.icon-villain').show();
    }

    const availability = data.availability.toLowerCase();
    update_availability(availability)
    updateNavText();


    const $images = $('.character-modal img');
    let loadedCount = 0;

    $images.each(function() {
        if (this.complete) {
            loadedCount++;
        } else {
            $(this).one('load', function() {
                loadedCount++;
                if (loadedCount === $images.length) {
                    onAllImagesLoaded();
                }
            }).one('error', function() {
                // in case of broken image, still count
                loadedCount++;
                if (loadedCount === $images.length) {
                    onAllImagesLoaded();
                }
            });
        }
    });

    // If all were already loaded
    if (loadedCount === $images.length) {
        onAllImagesLoaded();
    }

    function onAllImagesLoaded() {
        $('.character-modal__mobi-btn-wrap button').removeClass('active');
        $('.character-modal__btn-character-view').addClass('active');
    }
}


$(".img-with-accordion__content-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".img-with-accordion__content-details").slideUp();
    } else {
        $(".img-with-accordion__content-details").slideUp();
        $(".img-with-accordion__content-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".img-with-accordion__content-details").slideDown();
    }
})

const img_items = $(".img-with-accordion__content-item");
const leftImages = $(".img-with-accordion__left .img-with-accordion__img");
img_items.each(function (index) {
    $(this).on("click", function () {
        img_items.removeClass("active");
        leftImages.removeClass("active").hide();
        $(this).addClass("active");
        $(leftImages[index])
            .addClass("active")
            .fadeIn(300);
    });
});


// section rendar in play game page start here

function updateCharacterSection(handle) {
   /* if (handle === 'all-character') {
        // Redirect to the full page for 'all-character'
        window.location.href = 'https://jungle-squad-snacks.myshopify.com/pages/all-character';
        return;
    }*/
    // For other characters, load the section via AJAX
    const newUrl = `/pages/character/${handle}`;

    fetch(`${newUrl}?section_id=character-details`)
        .then(res => res.text())
        .then(data => {
            const sectionHTML = $(data);
            const newContent = sectionHTML.find(".episodes-card").html();

            $(".episodes-card").html(newContent);

            window.history.pushState({}, '', newUrl);
        })
        .catch(err => {
            console.error("Failed to load character section:", err);
        });
}






$("#characters").on("change", function () {
    const selectedHandle = $(this).find("option:selected").attr("data-value");

    if (selectedHandle) {
        updateCharacterSection(selectedHandle);
    }
});



// section rendar in play game page end here


$(".episodes-card__bot-img").on("click", function (e) {

});

function redirectPage(event, $el) {
    event.preventDefault();

    let data_value = $($el).attr("data-title");
    const url = $($el).attr("href");

    // Encode the value and append as query parameter
    const newUrl = `${url}?character=${encodeURIComponent(data_value)}`;

    // Redirect with data in URL
    window.location.href = newUrl;
}










// Open modal on card click
$(".character-card__item").on("click", function () {
    currentCharacterIndex = $(this).index(".character-card__item");
    updateModal(characterData[currentCharacterIndex]);

    $("body").addClass("character-modal-open");
    if (window.innerWidth > 1024) {
        $(".character-modal").hide().fadeIn(300);
    } else {
        $(".character-modal").show();
    }
});

// Handle prev/next nav clicks
$(".modal-nav").on("click", function (e) {
    e.preventDefault();
    const direction = $(this).data("direction");

    if (direction === "next") {
        currentCharacterIndex = (currentCharacterIndex + 1) % characterData.length;
    } else if (direction === "prev") {
        currentCharacterIndex =
            (currentCharacterIndex - 1 + characterData.length) % characterData.length;
    }

    updateModal(characterData[currentCharacterIndex]);
});





$(document).ready(function () {
    const params = new URLSearchParams(window.location.search);
    const urlTitle = params.get("character");

    if (urlTitle) {
        const lowerTitle = urlTitle.toLowerCase();
        const matchIndex = characterData.findIndex(char => {

                return char.title && char.title.toLowerCase() === lowerTitle;
            }

        );

        if (matchIndex !== -1) {
            currentCharacterIndex = matchIndex;
            updateModal(characterData[currentCharacterIndex]);

            // Show modal
            $("body").addClass("character-modal-open");
            if (window.innerWidth > 1024) {
                $(".character-modal").hide().fadeIn(300);
            } else {
                $(".character-modal").show();
            }
        }
    }


    if(params.get("cartr") == "y"){
        $("body").addClass("cart-open");
    }
});






/*$(document).ready(function () {
    const $video = $(".adventure-watch__video video");
    const $playIcon = $(".adventure-watch__video-play-icon");

    $playIcon.on("click", function () {
        $video.prop("muted", false);
        $video.get(0).play();
        $playIcon.hide();
    });

    $video.on("click", function () {
        if ($video.get(0).paused) {
            $video.prop("muted", false);
            $video.get(0).play();
            $playIcon.hide();
        } else {
            $video.get(0).pause();
            $playIcon.show();
        }
    });
});*/


$(document).ready(function () {
    const $video = $(".quest__video video");
    const $playIcon = $(".quest__video-play-icon");

    $playIcon.on("click", function () {
        $video.prop("muted", false);
        $video.get(0).play();
        $playIcon.hide();
    });

    $video.on("click", function () {
        if ($video.get(0).paused) {
            $video.prop("muted", false);
            $video.get(0).play();
            $playIcon.hide();
        } else {
            $video.get(0).pause();
            $playIcon.show();
        }
    });
});






// function updateNavText() {
//     const prevBtn = $(".modal-nav[data-direction='prev']");
//     const nextBtn = $(".modal-nav[data-direction='next']");

//     const isFirst = currentCharacterIndex === 0;
//     const isLast = currentCharacterIndex === characterData.length - 1;

//     // Set previous title or "Prev"
//     if (!isFirst) {
//         prevBtn.text(characterData[currentCharacterIndex - 1].title);
//     } else {
//         prevBtn.text(characterData[currentCharacterIndex].title);
//     }

//     // Set next title or "Next"
//     if (!isLast) {
//         nextBtn.text(characterData[currentCharacterIndex + 1].title);
//     } else {
//         nextBtn.text(characterData[currentCharacterIndex].title);
//     }

//     // Disable navigation if at beginning or end
//     prevBtn.toggleClass("disabled", isFirst);
//     nextBtn.toggleClass("disabled", isLast);
// }






// new end here 





// Close modal



$(".character-modal__close").on("click", function () {
    $("body").removeClass("character-modal-open");

});
$(".overlay").on("click", function () {
    $("body").removeClass("character-modal-open");
    // $(".character-modal").hide();
});



$(document).ready(function () {
    $(".character-card__item").each(function () {
        const pic = $(this).data("pic");
        const cardImg = $(this).data("card-img");

        // Trim in case of empty string with whitespace
        if (!pic?.trim() && !cardImg?.trim()) {
            $(this).addClass("disabled").css("pointer-events", "none");
        }
    });
});


// character-modal end



// play-show-hero start
/*
document.addEventListener("DOMContentLoaded", function () {
    const videoCards = document.querySelectorAll(".play-show-hero__video");
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const modalSource = modalVideo.querySelector("source");
    const closeBtn = document.querySelector(".play-show-hero__video-modal-close");
    // Open modal and load video
    videoCards.forEach(card => {
        card.addEventListener("click", function () {
            const source = card.querySelector("source").getAttribute("src");
            modalSource.setAttribute("src", source);
            modalVideo.load();
            modal.style.display = "block";
            document.body.classList.add("video-modal-open");
        // If modalVideo contains class 'header-video-modal', add 'header-modal' to body
        if (modalVideo.classList.contains('header-video-modal')) {
            document.body.classList.add('header-modal');
        }
        });
    });
    // Close modal function
    function closeModal() {
        modal.style.display = "none";
        modalVideo.pause();
        modalSource.setAttribute("src", "");
        document.body.classList.remove("video-modal-open");
    }
    // Close modal on close button click
    closeBtn.addEventListener("click", closeModal);
    // Close modal on click outside the video
    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });
});
*/
// play-show-hero end





// episodes start




// document.addEventListener("DOMContentLoaded", function () {
//     const videoCards = document.querySelectorAll(".episodes-card__video");
//     const modal = document.getElementById("videoModal");
//     const modalVideo = document.getElementById("modalVideo");
//     const modalSource = modalVideo.querySelector("source");
//     const closeBtn = document.querySelector(".episodes-card__video-modal-close");

//     videoCards.forEach(card => {
//         card.addEventListener("click", function () {
//             const source = card.querySelector("source").getAttribute("src");
//             modalSource.setAttribute("src", source);
//             modalVideo.load();
//             modal.style.display = "block";
//             document.body.classList.add("video-modal-open"); // ✅ Add class to body
//         });
//     });


//     function closeModal() {
//         modal.style.display = "none";
//         modalVideo.pause();
//         modalSource.setAttribute("src", "");
//         document.body.classList.remove("video-modal-open"); // ✅ Remove class from body
//     }

//     closeBtn.addEventListener("click", closeModal);

//     window.addEventListener("click", function (e) {
//         if (e.target === modal) {
//             closeModal();
//         }
//     });

//     $(".overlay").on('click', function () {
//         $("body").removeClass("video-modal-open");
//         closeModal();
//     });
// });


// document.addEventListener("DOMContentLoaded", function () {


const modal = document.getElementById("videoModal");
const modalVideo = document.getElementById("modalVideo");
const modalSource = modalVideo ? modalVideo.querySelector("source") : null;
const closeBtn = document.querySelector(".episodes-card__video-modal-close");

// If the episodes video modal is not present on this page, skip wiring it up.
if (modal && modalVideo && modalSource) {

function openModal(card) {
 
    const source = card.querySelector("source").getAttribute("src");
    const poster = card.querySelector("video").getAttribute("poster");

    modalSource.setAttribute("src", source);
    modalVideo.setAttribute("poster", poster);
    modalVideo.load();
    modal.style.display = "block";
    document.body.classList.add("video-modal-open");
    if (modal.classList.contains('header-video-modal')) {
        document.body.classList.add('header-modal');
    }
}

// Close modal
if (closeBtn) {
    closeBtn.addEventListener("click", function () {
        modalVideo.pause();
        modal.style.display = "none";
        document.body.classList.remove("video-modal-open");
        document.body.classList.remove('header-modal');
    });
}

// Optional: Close with ESC
document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        modalVideo.pause();
        modal.style.display = "none";
        document.body.classList.remove("video-modal-open");
    }
});


$(".overlay").on('click', function () {
    $("body").removeClass("video-modal-open");
    // closeModal();
    modalVideo.pause();
        modal.style.display = "none";
});
// });



} // end guard for episodes video modal existence


// Script to open all offsite links in a new tab
document.addEventListener("DOMContentLoaded", function () {
    var links = document.querySelectorAll('a[href^="http"]');
    links.forEach(function(link) {
        // Only set target if link is offsite
        if (link.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });
});





$(".episodes__bot-yt").on('click', function () {
    $('body').addClass("yt-modal-show");
})
$(".episodes-yt-modal__close , .overlay").on('click', function () {
    $('body').removeClass("yt-modal-show");
})

// episodes end






// begin start


$('.begin__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
});



$('.begin__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.begin__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// begin end






// ways-play start


if ($(Window).width() < 768) {
    $('.ways-play-card').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}




// ways-play end






// jungle-is-on start
document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const modalSource = modalVideo ? modalVideo.querySelector("source") : null;
    const closeBtn = document.getElementById("closeVideoModal");

    // If this page doesn't have the jungle-is-on modal, skip wiring it up.
    if (!modal || !modalVideo || !modalSource || !closeBtn) {
        return;
    }

    // Open modal
    document.querySelectorAll(".jungle-is-on__video, .jungle-is-on__video-play-icon").forEach(trigger => {
        trigger.addEventListener("click", function (e) {
            const parentVideo = e.target.closest(".jungle-is-on__video");
            if (!parentVideo) return;

            const sourceEl = parentVideo.querySelector("source");
            if (!sourceEl) return;

            const source = sourceEl.getAttribute("src");
            if (!source) return;

            modalSource.setAttribute("src", source);
            modalVideo.load();
            modal.style.display = "block";
            document.body.classList.add("video-modal-open");
            modalVideo.play();
        });
    });

    // Close modal
    function closeModal() {
        modal.style.display = "none";
        modalVideo.pause();
        modalSource.setAttribute("src", "");
        document.body.classList.remove("video-modal-open");
    }

    closeBtn.addEventListener("click", closeModal);
    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });
    $(".overlay").on('click', function () {
        $('body').removeClass("video-modal-open");
        closeModal();
    });
});
// jungle-is-on end


// rulebook start





// tickertape marquee start


$(".tickertape__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});


// tickertape marquee end







// rulebook end


// $("[href^='#']").click(function() {
//     id=$(this).attr("href")
//     $('html, body').animate({
//         scrollTop: $(id).offset().top
//     }, 1000);
//   });


// Smooth scroll for in-page anchors, excluding plain "#" placeholders
// Uses delegated event so it also works for dynamically injected links
/*
$(document).on("click", "a[href^='#']:not([href='#'])", function (e) {
    console.log('click');
    var id = $(this).attr("href");

    if (!id || id === "#") {
        return;
    }

    var $target = $(id);
    if ($target.length) {
        e.preventDefault();
        var targetOffset = $target.offset().top - 100;
        $("html, body").animate(
            {
                scrollTop: targetOffset >= 0 ? targetOffset : 0,
            },
            600,
            function () {
                var highlightClass = "scroll-highlight-animation";
                $target.addClass(highlightClass);
                setTimeout(function () {
                    $target.removeClass(highlightClass);
                }, 3000);
            }
        );
    }
});
*/







        





















